<div class="btn-group d-block primary-dropdown w-100 kh-lg-title-text" dropdown [isDisabled]="disabled">
    <button class="h-100 w-100 
    d-flex align-items-center breadcrumb-dropdown-toggle justify-content-between grey-accessible bg-grey-medium-light px-kh-3 py-kh-2" dropdownToggle type="button" aria-controls="dropdown-menu" [ngClass]="{selected : !!selectedItem}" role="button" data-testid="breadcrumbs-dropdown-button">
        <div [ngClass]="{ 'inactive': !isActive }" class="d-block mr-xs text-truncate kh-black kh-lg-title-text main-text">{{resolveName(selectedItem)}}</div>
        
        <div class="pl-kh-2"><fa-icon [icon]="['fas', 'caret-down']" [ngClass]="[arrowColor]"></fa-icon></div>
    </button>
    <ul class="dropdown-menu primary-dropdown-list border-radius-sm mt-xs" *dropdownMenu id="dropdown-menu" role="menu" aria-labelledby="button-animated" data-testid="breadcrumbs-dropdown-menu">
        <li *ngFor="let item of items" role="button" class="primary-dropdown-item  kh-lg-title-text black p-xxs m-xs border-radius-sm " data-testid="breadcrumbs-dropdown-item" (click)="onItemClick(item)">
        {{resolveName(item)}}
        </li>
    </ul>
</div>
  